import {
  defaultFailedSendCreditTransactionsListFilter,
  defaultFailedSendCreditTransactionsListColumnVisibility,
  failedSendCreditTransactionsListColumnVisibilityOptions,
} from '@utils/tables/failedSendCreditTransactions/failedSendCreditTransactionsListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  limit: 25,
  page: 1,
  total: 0,
  failedSendCreditTransactionsTableFilters: {},
  selectedFilters: defaultFailedSendCreditTransactionsListFilter,
  columnVisibility: defaultFailedSendCreditTransactionsListColumnVisibility,
  columnVisibilityOptions: failedSendCreditTransactionsListColumnVisibilityOptions,
};

const failedSendCreditTransactionsTableSlice = createSlice({
  name: 'failedSendCreditTransactionsTable',
  initialState,
  reducers: {
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setFailedSendCreditTransactionsTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { failedSendCreditTransactionsTableFilters } = state;

      const newRoundTableFilters = {
        ...failedSendCreditTransactionsTableFilters,
        [codeName]: value,
      };
      state.failedSendCreditTransactionsTableFilters = newRoundTableFilters;
    },
    setClearFailedSendCreditTransactionsTableFilters: (state) => {
      state.failedSendCreditTransactionsTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: failedSendCreditTransactionsTableReducer } =
  failedSendCreditTransactionsTableSlice;
export const {
  setColumnVisibility,
  setLimit,
  setPage,
  setTotal,
  setFailedSendCreditTransactionsTableFilters,
  setClearFailedSendCreditTransactionsTableFilters,
} = failedSendCreditTransactionsTableSlice.actions;
